export default __webpack_public_path__ + "static/media/DoubleDay11_750x600.8f37e00d.jpg";